
export function getNumeroDialCodePorHtmlIntlTel (numeroElementID) {
    const inputNumero = document.getElementById(numeroElementID);

    if(!inputNumero)
        return "";

    const intlTelNumero = window.intlTelInputGlobals.getInstance(inputNumero);

    if(!intlTelNumero)
        return "";

    const countryData = intlTelNumero.getSelectedCountryData();

    return countryData.dialCode;
};